import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthGuard } from './auth/AuthGuard';
import LoginPage from './pages/LoginPage';
import ProfileSettings from './pages/ProfileSettings';
import DashboardLayout from './pages/DashboardPage';
import {
  DashboardHome,
  PartyMaster,
  PartyAccounts,
  TokenMaster,
  DollarAccounts,
  InternalAccounts,
  PaymentModes,
  Ledger,
  DailyClosing,
  Reports,
  UserManagement,
  AuditLogs,
} from './pages/DashboardPage/sections';
import { Buy, Sell, Swap } from './pages/DashboardPage/sections/transactions';
import './App.css';

/**
 * App component with React Router configuration
 * 
 * Route structure:
 * - / → redirects to /dashboard
 * - /login → LoginPage (public)
 * - /dashboard → AuthGuard (protected layout route)
 *   - index → DashboardHome
 *   - parties → PartyMaster
 *   - party-accounts → PartyAccounts
 *   - tokens → TokenMaster
 *   - dollar-accounts → DollarAccounts
 *   - internal-accounts → InternalAccounts
 *   - payment-modes → PaymentModes
 *   - transactions/buy → Buy (transaction)
 *   - transactions/sell → Sell (transaction)
 *   - transactions/swap → Swap (transaction)
 *   - ledger → Ledger (report)
 *   - daily-closing → DailyClosing (report)
 *   - reports → Reports (report)
 *   - audit-logs → AuditLogs
 *   - users → UserManagement
 *   - profile-settings → ProfileSettings
 * 
 * Requirements: 2.1, 2.2, 2.3, 2.4
 */
function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Root redirect */}
        <Route path="/" element={<Navigate to="/dashboard" replace />} />
        
        {/* Public route */}
        <Route path="/login" element={<LoginPage />} />
        
        {/* Protected routes - wrapped in AuthGuard */}
        <Route path="/dashboard" element={<AuthGuard />}>
          {/* Dashboard layout wraps all sub-routes */}
          <Route element={<DashboardLayout />}>
            <Route index element={<DashboardHome />} />
            {/* Party routes */}
            <Route path="party-master" element={<PartyMaster />} />
            <Route path="party-accounts" element={<PartyAccounts />} />
            {/* Token routes */}
            <Route path="token-master" element={<TokenMaster />} />
            {/* Account routes */}
            <Route path="dollar-accounts" element={<DollarAccounts />} />
            <Route path="internal-accounts" element={<InternalAccounts />} />
            {/* Payment routes */}
            <Route path="payment-modes" element={<PaymentModes />} />
            {/* Transaction routes */}
            <Route path="buy" element={<Buy />} />
            <Route path="sell" element={<Sell />} />
            <Route path="swap" element={<Swap />} />
            {/* Report routes */}
            <Route path="ledger" element={<Ledger />} />
            <Route path="daily-closing" element={<DailyClosing />} />
            <Route path="reports" element={<Reports />} />
            {/* Admin routes */}
            <Route path="audit-logs" element={<AuditLogs />} />
            <Route path="users" element={<UserManagement />} />
            <Route path="profile-settings" element={<ProfileSettings />} />
          </Route>
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
